import { observer } from 'mobx-react';
import * as React from 'react';
import Breadcrumb from './Breadcrumb';
import { T } from '../../../Translations';

const Heading: React.FC = () => {
  return (
    <div className="mx-auto w-full max-w-clientPortalMaxWidth overflow-x-hidden">
      <div className="border-t px-2.5 pb-7 pt-5 lg:px-12">
        <Breadcrumb />
        <h1 className="text-xl font-semibold leading-7 text-gray-100">
          <T kind="Import Participants" />
        </h1>
      </div>
    </div>
  );
};

export default observer(Heading);
